import { ReactNode } from "react";
import { useGetABOProfileQuery } from "../../services/AboProfile/AboProfileAPI";
import { useAppSelector } from "../../store";
type Props = {
  affAbo: string;
  children: ReactNode;
};

const DownlineProfileDataLayer = ({ affAbo, children }: Props) => {
  const [aff = "", abo = ""] = (affAbo ?? "").split("-");
  const isFromEdLos = useAppSelector((s) => s.profile.isFromEdLos);
  // ponytail: data unused until U2/U5 populate sections; keeping query here so cache warms on open
  useGetABOProfileQuery(
    { aff, abo, ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}) },
    { skip: !aff || !abo },
  );

  return <>{children}</>;
};

export default DownlineProfileDataLayer;
